import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import TodosAllItem from './TodosAllItem';
import { fetchOrders } from '../../actions/orderActions'
import { fetchTodos, editTodo } from "../../actions/todoActions"
import { fetchTodolists } from "../../actions/todolistActions"
import { sortOpts } from '../../utils/utils';

class TodosAll extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      user_id: props.myTodos ? props.user.user_id : 0
    }
  }

  componentWillMount(){
    this.props.fetchTodos({calendar: 1});
    this.props.fetchTodolists({calendar: 1});
    this.props.fetchOrders();
  }

  handleSearch = e => {
    this.setState({
      search: e.target.value
    });
  }

  clearSearch = () => {
    this.setState({
      search: ''
    });
  }

  updateUserId = e => {
    this.setState({
      user_id: e ? e.value : 0
    });
  }

  render() {
    const { orders, todos, todolists, users, editTodo, myTodos } = this.props;
    const { user_id, search } = this.state;
    const ordersObject = {};
    for (let i = 0; i < orders.length; i++) {
      ordersObject[orders[i].order_id] = orders[i];
    }
    const todolistsObject = {};
    for (let i = 0; i < todolists.length; i++) {
      todolistsObject[todolists[i].todolist_id] = todolists[i];
    }
    const todosActive = todos.filter(el => el.todo_active);
    const todosFiltered = todosActive.filter(el => {
      let userFiltered = false,
          searchFiltered = false;
      if (user_id === 0 || el.todo_user_id === user_id) userFiltered = true;
      if (!search || el.todo_desc.toLowerCase().indexOf(search) !== -1) searchFiltered = true;
      return userFiltered && searchFiltered;
    });
    todosFiltered.sort((a, b) => {
      if (a.todo_dline < b.todo_dline) return -1;
      if (a.todo_dline > b.todo_dline) return 1;
      return 0;
    });
    var usersOpt = [];
    for (let key in users){
      if(users.hasOwnProperty(key) && users[key].user_active){
        usersOpt.push({
          value: users[key].user_id,
          label: users[key].user_fname + " " + users[key].user_lname
        });
      }
    }
    usersOpt.sort(sortOpts);
    return (
      <div>
        <h3 className="pull-right">Задачи</h3>
        <div className="form-group form-inline">
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              value={search || ''}
              title="Поиск"
              placeholder="Поиск"
              onChange={this.handleSearch}
            />
            <div className="input-group-btn">
              <button
                type="button"
                className="btn btn-default"
                onClick={this.clearSearch}
                title="Очистить поиск">
                X
              </button>
            </div>
          </div>{" "}
          {!myTodos && (
            <div className="input-group col-sm-3">
              <Select
                options={usersOpt}
                value={user_id || 0}
                onChange={this.updateUserId}
                placeholder="Исполнитель"
              />
            </div>
          )}{" "}
          <div className="input-group">{todosFiltered.length} записей</div>
        </div>
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th></th>
              <th className="col-xs-3">Задача</th>
              <th className="col-xs-3">Чек-лист</th>
              <th className="col-xs-3">Заказ</th>
              <th className="col-xs-1">Дедлайн</th>
              <th className="col-xs-2">Исполнитель</th>
            </tr>
          </thead>
          <tbody>
            {todosFiltered.map(el => {
              return (
                <TodosAllItem
                  key={el.todo_id}
                  users={users}
                  data={el}
                  editTodo={editTodo}
                  todolist={todolistsObject[el.todo_todolist_id]}
                  order={ordersObject[(todolistsObject[el.todo_todolist_id] || {}).todolist_order_id]}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

function mapStoreToProps(store) {
  return {
    todos: store.todos,
    todolists: store.todolists,
    users: store.empls,
    orders: store.orders.data,
    user: store.auth.user
  }
}

export default connect(mapStoreToProps, {
  fetchTodos,
  fetchTodolists,
  fetchOrders,
  editTodo
})(TodosAll);



// WEBPACK FOOTER //
// ./src/components/todo/TodosAll.js